import { GetServerSidePropsContext, NextComponentType, NextPageContext } from 'next';
import React from 'react';
import { v4 } from 'uuid';

export const SESSION_COOKIE_NAME = 'x-chromatic-session-id';

export const ensureChromaticSessionId = ({ req, res }: GetServerSidePropsContext) => {
  const sessionId =
    req.headers['x-chromatic-session-id'] || req.cookies[SESSION_COOKIE_NAME] || v4();
  if (!req.cookies[SESSION_COOKIE_NAME]) {
    res.setHeader('Set-Cookie', `${SESSION_COOKIE_NAME}=${sessionId};HttpOnly;Secure;`);
  }

  return Array.isArray(sessionId) ? sessionId[0] : sessionId;
};

// client side access to session id via this singleton
let globalSessionId: string;
export const getSessionId = () => globalSessionId;

export const withSessionId = <TComposed extends NextComponentType<NextPageContext, {}, {}>>(
  ComposedComponent: TComposed
) =>
  class WithSessionId extends React.Component<{ sessionId: string }> {
    static async getInitialProps(ctx: NextPageContext) {
      let composedInitialProps = {};
      if (ComposedComponent.getInitialProps) {
        composedInitialProps = await ComposedComponent.getInitialProps(ctx);
      }

      if (ctx.req) {
        const sessionId = ensureChromaticSessionId(ctx as any);

        return {
          sessionId,
          ...composedInitialProps,
        };
      }
      return composedInitialProps;
    }

    render() {
      const { sessionId, ...composedInitialProps } = this.props;

      globalSessionId ||= sessionId;

      /* @ts-expect-error I don't know how to type composedInitialProps properly here */
      return <ComposedComponent {...composedInitialProps} />;
    }
  };
